import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const tandoorRecipes = defineConnector({
  identifier: "tandoorRecipes",
  name: "Tandoor Recipes",
  tagLine: "Self-hosted recipe manager and meal planner",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Enter your Tandoor details",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://tandoor.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Tandoor Recipes instance.",
        },
      ],
    },
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Tandoor, go to the **API Browser** (usually at `/docs/api/`) and create an API token.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/recipe/`,
  },
});
